import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type { UnitRequest, UnitResponse } from '@/types/product';

export const unitsApi = {
  list: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<UnitResponse>>>('/v1/units', { params })),

  get: (id: number) => unwrap(api.get<ApiResponse<UnitResponse>>(`/v1/units/${id}`)),

  create: (body: UnitRequest) =>
    unwrap(api.post<ApiResponse<UnitResponse>>('/v1/units', body)),

  update: (id: number, body: UnitRequest) =>
    unwrap(api.put<ApiResponse<UnitResponse>>(`/v1/units/${id}`, body)),

  delete: (id: number) => unwrap(api.delete<ApiResponse<null>>(`/v1/units/${id}`)),

  activate: (id: number, active: boolean) =>
    unwrap(
      api.patch<ApiResponse<UnitResponse>>(`/v1/units/${id}/activate`, null, {
        params: { active },
      }),
    ),
};
